import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActiveInactive from './ActiveInactive';
import { getoffRoleEmployeesData, getDataForDropdown, updateStatusOffroleEmployee } from 'services/redux/OffRoleEmployees/action';

const mapStateToProps = (state) => ({
    getEmployeesListing: state.offroleEmployeesReducer.getEmployeesListing,
    getDropdownDatas: state.offroleEmployeesReducer.getDropdownDatas,
    statusUpdationByBusinessHead: state.offroleEmployeesReducer.statusUpdationByBusinessHead
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getoffRoleEmployeesData,
        getDataForDropdown,
        updateStatusOffroleEmployee
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ActiveInactive);
